import type { User } from '@/store/modules/auth';

export const isMultiSiteAdmin = (user: User | null | undefined): boolean =>
  ['gerant', 'superadmin', 'super_admin'].includes(String(user?.role || ''));
